module.exports = __webpack_public_path__ + "img/buildings-active.b8e16636.svg";